import { render, staticRenderFns } from "./effect-option.modal.vue?vue&type=template&id=34f74a2c&"
import script from "./effect-option.modal.vue?vue&type=script&lang=js&"
export * from "./effect-option.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports